import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import Chip from '@mui/material/Chip';

import { usePluginsContext } from '../../../hooks';
import { formatDateMmDdYyyy, lowerCapitalize } from '../../../utils';
import { StyledTableRow } from './styles';
import VpPluginInfoMenu from './VpPluginInfoMenu';
import { getIsOrganizationViewer } from '../../../redux/modules/organization';
import { getPluginStatsEnabled } from '../../../redux/modules/auth';

export const VpPluginsTableBody = withRouter(({ history, isOrgViewer, showStats }) => {
  const { pluginList } = usePluginsContext();

  const handleRowClick = (id) => {
    history.push(`/v2/plugins/${id}`);
  };

  return (
    <TableBody>
      {pluginList?.map((plugin) => (
        <StyledTableRow hover key={plugin?.id} onClick={() => handleRowClick(plugin?.id)}>
          <TableCell>{plugin?.name}</TableCell>
          <TableCell>
            <Chip label={lowerCapitalize(plugin?.type)} />
          </TableCell>
          {showStats && (
            <>
              <TableCell></TableCell>
              <TableCell></TableCell>
            </>
          )}
          <TableCell>{formatDateMmDdYyyy(plugin.createdDate)}</TableCell>
          <TableCell padding="checkbox">
            {!isOrgViewer && <VpPluginInfoMenu pluginId={plugin?.id} />}
          </TableCell>
        </StyledTableRow>
      ))}
    </TableBody>
  );
});

const mapStateToProps = (state) => ({
  isOrgViewer: getIsOrganizationViewer(state),
  showStats: getPluginStatsEnabled(state)
});

export default connect(mapStateToProps)(VpPluginsTableBody);



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpPluginsTable/VpPluginsTableBody.jsx